import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  accountCard: {
    padding: theme.spacing(8),
    position: 'relative',
    overflowWrap: 'anywhere'
  },
  buttonContainer: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '100%'
  },
  inviterLink: {
    color: theme.colorPalette.orange_50
  },
  secondaryPhoneContainer: {
    border: `3px solid ${theme.colorPalette.white}`,
    borderRadius: 3,
    padding: '10px 20px 10px 20px',
    margin: '15px 0px'
  },
  affinityRow: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: theme.spacing(2)
  },
  affinityLink: {
    color: theme.colorPalette.orange_50,
    textDecoration: 'none',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    paddingBottom: theme.spacing(2)
  }
});

export default makeStyles(styles);
